var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.51.49a1.63 1.63 0 0 1 .49 1.2v10.12a1.67 1.67 0 0 1-1.69 1.69H1.69a1.63 1.63 0 0 1-1.2-.5A1.63 1.63 0 0 1 0 11.81V1.69A1.63 1.63 0 0 1 .49.49 1.63 1.63 0 0 1 1.69 0h14.62a1.63 1.63 0 0 1 1.2.49zM1.69 1.69v1.44q1.23 1 4.74 3.73l.32.28A7.59 7.59 0 0 0 7.88 8 2.09 2.09 0 0 0 9 8.44 2.09 2.09 0 0 0 10.12 8a7.59 7.59 0 0 0 1.13-.84l.32-.28q3.51-2.72 4.74-3.73V1.69zm14.62 10.12V5.27l-4.08 3.24a9.6 9.6 0 0 1-1.44 1.05 3.48 3.48 0 0 1-1.79.56 3.69 3.69 0 0 1-1.83-.56 14.14 14.14 0 0 1-1.44-1.05l-4-3.24v6.54z"}));
}

Mail.defaultProps = {"viewBox":"0 0 18 13.5"};

module.exports = Mail;

Mail.default = Mail;
